import type { TickerMarketType } from '../domain'

/**
 * Demo / client classify for Lab Market Types filter.
 * Mirrors Agent-API ticker priority: Bookmaker → Linesession → Fancy → Match Odds.
 */
export function classifyTickerMarketType(marketName: string): TickerMarketType {
  const name = marketName.toLowerCase()
  if (
    name.includes('bookmaker') ||
    name.includes('premium') ||
    name.includes('artemis')
  ) {
    return 'Bookmaker'
  }
  if (
    name.includes('line ladder') ||
    name.includes('line-session') ||
    name.includes('linesession') ||
    (name.includes('line') && name.includes('session'))
  ) {
    return 'Linesession'
  }
  if (name.includes('fancy') || name.includes('session')) {
    return 'Fancy'
  }
  return 'Match Odds'
}
